import { useEffect } from 'react';

const GoogleOneTap = ({ uid }) => {
    useEffect(() => {
        const host = window.location.host;
        let clientId = '600429165663-d7r3oflvi12jmk549m2bmec4tijjmlpb.apps.googleusercontent.com';
        if (host.endsWith('sounova.com')) {
            clientId = '849779391813-l0c33mi61r7pdho8oddg9qld7uhnfgnr.apps.googleusercontent.com';
        }

        const scriptSrc = 'https://accounts.google.com/gsi/client';

        if (!window.__googleOneTapScriptInjected && !uid) {
            window.__googleOneTapScriptInjected = true;

            const script = document.createElement('script');
            script.src = scriptSrc;
            script.async = true;
            script.defer = true;
            script.onload = () => {
                if (window.google && window.google.accounts) {
                    window.google.accounts.id.initialize({
                        client_id: clientId,
                        callback: async (response) => {
                            const res = await fetch('/api/v1/auth/callback/google-one-tap', {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json' },
                                body: JSON.stringify({ credential: response.credential }),
                            });
                            if (res?.ok) window.location.reload();
                        },
                        auto_select: false,
                        cancel_on_tap_outside: false,
                        use_fedcm_for_prompt: false,
                    });

                    window.google.accounts.id.renderButton(
                        document.getElementById('g_id_signin_btn'),
                        {
                            theme: 'outline',
                            size: 'large',
                            width: 240,
                        }
                    );
                }
            };

            document.body.appendChild(script);
        }
    }, [uid]);

    if (!uid) {
        return (
            <div
                className="flex items-start gap-x-[12px] umd:hidden"
                style={{
                    position: 'fixed',
                    top: '65px',
                    right: '20px',
                    zIndex: 50,
                }}
            >
                <div id="g_id_signin_btn" className="overflow-hidden rounded-[3px]" />
            </div>
        );
    }

    return null;
};

export default GoogleOneTap;
